export class StartProcessingCSVFilesEvent extends CustomEvent {
  static get name() { return 'startProcessingCSVFiles'; }
  constructor(detail) {
    super(StartProcessingCSVFilesEvent.name, { detail });
  }
}

export class EndProcessingCSVFilesEvent extends CustomEvent {
  static get name() { return 'endProcessingCSVFiles'; }
  constructor(detail) {
    super(EndProcessingCSVFilesEvent.name, { detail });
  }
}

/**
 * An event notification for when the processing of a CSV file has begun.
 */
export class ProcessingCSVFileEvent extends CustomEvent {
  static get name() { return 'processingCSVFile'; }
  /**
   * An event notification for when the processing of a CSV file has begun.
   * 
   * @param {string} filename The name of the file being processed.
   */
  constructor (filename) {
    super(ProcessingCSVFileEvent.name, { detail: { filename }});
  }
}

/**
 * An event notification for when an error is encounterd during the processing of the CSV file.
 */
export class ProcessingErrorEvent extends CustomEvent {
  static get name() { return 'processingCSVError'; }
  /**
   * An event notification for when an error is encounterd during the processing of the CSV file.
   * 
   * @param {Error} error The error instance, or error-like instance, thrown.
   */
  constructor (error) {
    super(ProcessingErrorEvent.name, { detail: { error }});
  }
}

export class ProcessedCSVRowEvent extends CustomEvent {
  static get name() { return 'processedCSVRow'; }
  /**
   * An event notification for when a CSV row is processed.
   * 
   * @param {object} options An object containing options available for the event.
   * @param {boolean} [success=true] Indicates if the row was processed successfully.
   * @param {Error|string} [error=null] Contains the Error instance or message if the row was not processed successfuly.
   */
  constructor (options) {
    const {
      success = true,
      error = null,
    } = options ?? {};
    super(ProcessedCSVRowEvent.name, { detail: { success, error }});
  }
}

export class ProcessingRowsEvent extends CustomEvent {
  static get name() { return 'processingRows'; }
  constructor (numberOfRows) {
    super(ProcessingRowsEvent.name, { detail: { numberOfRows }});
  }
}

export class EndProcessingCSVFileEvent extends CustomEvent {
  static get name() { return'endProcessingCSVFile'; }
  /**
   * A notification event indicating that processing of a file has ended.
   * 
   * @param {string} filename The name of the file that was being processed.
   */
  constructor (filename) {
    super(EndProcessingCSVFileEvent.name, { detail: { filename }});
  }
}
